import { useEffect, useState } from 'react';
import { LocateClinicStatsDistrictsAPI } from '../../../../api/API';

/** Tentativas seguidas sem avanço (outra tela já localizando, serviço fora) antes de desistir. */
const MAX_STALLED = 2;
const STALLED_WAIT_MS = 3000;

/**
 * Pontos do mapa de calor. Começa com o que veio na seção Pacientes e, se
 * houver bairros ainda sem localização (`pending`), chama
 * statistics/geocode.php em sequência (cada chamada localiza alguns) até
 * acabar ou parar de avançar.
 *
 * @returns {{ map: { points, pending, notFound, withoutDistrict }, locating: boolean }}
 */
export default function useDistrictMap(initial, period) {
  const [map, setMap] = useState(initial);
  const [locating, setLocating] = useState(false);

  useEffect(() => {
    setMap(initial);
    if (!initial || initial.pending === 0) {
      setLocating(false);
      return undefined;
    }

    let active = true;
    let timer = null;
    let stalled = 0;
    let lastPending = initial.pending;
    setLocating(true);

    const step = () => {
      LocateClinicStatsDistrictsAPI(period.start, period.end, (response) => {
        if (!active) return;
        if (response && response.success) {
          setMap(response.data);
          if (response.data.pending === 0) {
            setLocating(false);
            return;
          }
          stalled = response.data.pending < lastPending ? 0 : stalled + 1;
          lastPending = response.data.pending;
        } else {
          stalled += 1;
        }
        if (stalled > MAX_STALLED) {
          setLocating(false);
          return;
        }
        timer = setTimeout(step, stalled > 0 ? STALLED_WAIT_MS : 0);
      });
    };
    step();

    return () => {
      active = false;
      clearTimeout(timer);
    };
  }, [initial, period.start, period.end]);

  return { map, locating };
}
